import React, { useEffect } from 'react'
import { AppMain } from './components/appRoutes'
import { BrowserRouter as Router } from 'react-router-dom'
import { CBInputMethod } from '@cb/apricot'
import { GlobalNotification, appPreferencesFamily } from '@landscape/ui-lib'
import { LoginManager } from './components/login'
import { NavBars } from './components/navigate'
import { WSListener } from './components/websocket/WSListener'
import { useRecoilValue } from 'recoil'

const { _satellite } = window
const App: React.FC = () => {
  const service_maintenance_mode = useRecoilValue(appPreferencesFamily('service_maintenance_mode'))

  useEffect(() => {
    CBInputMethod()
    if (typeof _satellite !== 'undefined') _satellite.track('cbTrack.viewInDom')
  }, [])

  if (service_maintenance_mode) {
    return (
      <div className="cb-padding-top-48 display-flex justify-content-center">
        <p>
          Landscape is currently undergoing system updates. The tool will be back online shortly
          once updates are complete.
        </p>
      </div>
    )
  }

  return (
    <div className="App">
      <Router>
        <LoginManager>
          <WSListener />
          <NavBars />
          <GlobalNotification />
          <AppMain />
        </LoginManager>
      </Router>
    </div>
  )
}

export { App }
